import React, {ReactNode, useContext} from 'react'
import { useTranslation } from 'react-i18next'

import cx from "classnames";
import IconButton from '@mui/material/IconButton';
import { Close as CloseIcon } from '@vedmarket/ui-kit';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import COLORS from 'styles/colors.scss'
import { DemoPlayerContext } from '../../cabinet/demo/player-clock'
import './modalBig.scss'

type Props = {
    onClose?: () => void;
    isOpen: boolean,
    title: React.ReactNode,
    children: ReactNode,
    isSearch?: boolean,
    insideModal?: boolean,
    noPadding?: boolean,
    width?: number
    buttons?: React.ReactNode,
    customStyles?: React.CSSProperties
}

const ModalBig = ({
  isOpen,
  onClose,
  title,
  children,
  isSearch,
  insideModal,
  noPadding,
  width,
  buttons,
  customStyles
}: Props) => {
  const { t } = useTranslation()

  const demoPlayer = useContext(DemoPlayerContext);
  const isSmallScreen = useMediaQuery('(max-width: 1199.95px)');
  const hasCompactViewport = demoPlayer ? true : isSmallScreen;
  const isCompact = Boolean(isSearch && hasCompactViewport);
  const fullscreenWidth = width || (isSearch ? 1120 : 736);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      scroll={isCompact ? 'paper' : 'body'}
      className={cx('application-modal-big', 'modal-big', {'modal-big_compact': isCompact})}
      aria-labelledby='scroll-dialog-title'
      aria-describedby='scroll-dialog-description'
      maxWidth={ isSearch ? 'xl' : false}
      disableEnforceFocus
      disableRestoreFocus
      BackdropProps={{ style: { pointerEvents: 'none' } }}
      PaperProps={{ style: { pointerEvents: 'auto' } }}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: width || '736px',
          right: insideModal ? '-24px' : 0,
          ...customStyles,
          ...(demoPlayer && {
            maxWidth: demoPlayer.isFullscreen
              ? `min(${fullscreenWidth}px, calc(100% - 64px))`
              : 'calc(100% - 64px)',
            maxHeight: 'calc(100% - 64px)',
            minWidth: 0,
            overflowY: 'auto',
          }),
          ...(isCompact && {
            width: width || 1120,
            maxWidth: 'calc(100% - 64px)',
            minWidth: 0,
            borderRadius: 0,
          }),
        },
      }}
    >
      <DialogTitle className='title' sx={{
        padding: '24px',
        borderBottom: 0,
        fontSize: '24px',
        fontWeight: 700,
        lineHeight: 1.28,
        minHeight: '55px',
        letterSpacing: 0,
      }}>
        {title}
        {onClose && <IconButton
          aria-label={t('actions__text__close')}
          color={COLORS.LIGHT_GRAY}
          sx={{
            padding: 0,
            '&.MuiIconButton-root': {
              marginRight: 0,
            },
            '&.MuiIconButton-root svg': {
              width: 24,
              height: 24,
            }
          }}
          onClick={onClose}
        >
          <CloseIcon style={{ width: '24px', height: '24px' }}/>
        </IconButton>}
      </DialogTitle>
      <DialogContent sx={{
        background: isSearch ? COLORS.WHITE: 'auto',
        padding: isSearch ? '0 !important': '32px 24px'
      }}>
        <div className={cx({
          'children': true,
          'children_isSearch': isSearch,
          'children_noPadding': noPadding,
        })}>
          {children}
        </div>
        {buttons}
      </DialogContent>
    </Dialog>
  )
}

export default ModalBig
